module.exports = __webpack_public_path__ + "static/media/EZ-BNB.dbd805e2.svg";